import PropTypes from "prop-types";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

import { Title } from "./title";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function RequirementHeader(props: any) {
  const { className, showEditor, title } = props;
  const handleClick = () => {
    showEditor(true);
  };

  return (
    <div className={className}>
      <Button size="small" onClick={handleClick}>
        <EditOutlined />
      </Button>
      <Title title={title} />
    </div>
  );
}

RequirementHeader.propTypes = {
  showEditor: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
